// extracted by mini-css-extract-plugin
export default {"emptyState":"_1eJ5P","updateEmptyState":"_1wE7E","title":"_20S7c","updateTitle":"_1foeU","text":"PsXd4","image":"_2doyl","noNotification":"_2rqvR"};